import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appOnlyDecimal]',
    standalone: false
})
export class OnlyDecimalDirective {

  private regex: RegExp = new RegExp(/^-?\d+([.,]\d{0,2})?$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];
  private numericKeys: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];


  constructor(private el: ElementRef) { }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1 ||
        (event.key.length === 1 && this.numericKeys.indexOf(event.key) !== -1)) {
      return;
    }

    // Prevent default action if not a number key or decimal point
    const inputValue: string = this.el.nativeElement.value.concat(event.key);
    if (!String(inputValue).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedInput = clipboardData.getData('text');
    if (!pastedInput.match(this.regex)) {
      event.preventDefault();
    }
  }
}
